define('models/pages/trade/index',['require','underscore','lib/utils','models/base/model','config/application','models/filter/index','./request/index','models/filter-list','./basket-items'],function(require) {
    'use strict';

    var _ = require('underscore'),
        utils = require('lib/utils'),
        Model = require('models/base/model'),
        appCfg= require('config/application'),
        FilterModel = require('models/filter/index'),
        RequestPageModel = require('./request/index'),
        FilterListModel = require('models/filter-list'),
        BasketItemsCollection = require('./basket-items');

    function _preprocessData(items) {
        var i, li, item;

        for (i=0, li = items.length; i<li; i++) {
            item = items[i];


            item.fullName = item.goodsTypeName + ' ' + item.goodsName + ' ' + item.Length;
            if (item.vendor !== item.sellerName) {
                item.fullName = item.fullName + ' (' + item.vendor + ')';
            }

            item.idx = i;

            var goodsProducerCountryName = item.goodsProducerCountryName ? item.goodsProducerCountryName.toLowerCase() : '';

            item.searchString = goodsProducerCountryName + item.sellerName.toLowerCase() + ' ' + item.fullName.toLowerCase();
        }

        return items;
    }


    // var TradeItem = Model.extend({
    //     defaults: {
    //         comment: ''
    //     }
    // });

    // var TradeItemsCollection = Collection.extend({
    //     model: TradeItem,
    //     initialize: function() {
    //         Chaplin.Collection.prototype.initialize.apply(this, arguments);
    //         _.extend(this, Chaplin.SyncMachine);
    //     }
    // });


    var TradePageModel = Model.extend({
        urlPath: '/page/trade',
        timerEnabled: true,
        timerInterval: 60000,
        defaults: {
            viewPageSize: 0,
            viewRowIndex: 0,
            // visibleRows: 0,

            loading: false,
            search: '',
            state: 'om',
            trade: {
                open: true,
                name: '',
                DisableFO : 1
            },
            // filter: {
            //     sellerNames: {},
            //     vendorNames: {},
            //     goodsNames: {},
            //     goodsTypeNames: {},
            //     lengths: {},
            //     prices: {
            //         max: 0,
            //         min: 0
            //     }
            // },

            viewData: [],

            canBuy: false,

            leftPos: 0,
            leftValue: 0,

            rightPos: 0,
            rightValue: 0,

            items: [],

            sum: 0,
            viewCurrency: '',

            pageSize: 100,
            pageOffset: 50,

            rowHeight: 24
        },
        constructor: function() {
            Model.apply(this, arguments);

            // this.items = new Collection(data ? data.items : [], { parse: true });
            // this.items = new TradeItemsCollection();
            this.basket = new BasketItemsCollection();
            this.request = new RequestPageModel({ id: this.get('tradeId') });

            this.filter = new FilterModel({ showSummary: true });
            this.filter.on('filterChanged', _.bind(this.onFilterChanged, this));

            this.on('change:viewRowIndex', this.onScrollTopChanged);
            this.on('change:search', this.onSearchChanged);

            this.filterList = new FilterListModel({ type: 'offer' });
            this.filterList.setFilter(this.filter);

            this.on('change:tradeId', function(value) {
                this.request.set('id', value);
            });


            this.basket.onGetAttributes = _.bind(function(attrubutes) {
                attrubutes.idTrade = this.get('tradeId');
                return attrubutes;
            }, this);

            this.basket.on('change:amount', _.bind(this.onUpdateBasketSum, this));
            this.basket.on('add remove reset', _.bind(this.onUpdateBasketSum, this));

            // this.on('change:currentFilter', _.bind(this.updateScrollData, this));
        },
        load: function() {
            this.filterList.load();

            return Model.prototype.load.apply(this, arguments);
        },
        parse: function(data) {

            var items,
            // filter,
            basket;

            if(data.trade.DisableFO === 1 && data.state === 'fo'){
                data.items = [];
            }

            items = _preprocessData(data.items);
            basket = _preprocessData(data.basket);

            delete data.items;

            this.set('trade', data.trade);
            this.set('viewCurrency', items.length ? items[0].viewCurrency : (basket.length ? basket[0].traderViewCurrency : ''));

            this.basket.reset(basket, { silent: true });

            this.updateBasketSum();
            this.timerStart();

            // this.items.trigger('reset');
            this.basket.trigger('reset');



            this.filter.setup({
                schema: [
                    {
                        name: 'goodsProducerCountryName',
                        caption: 'Страна производства'
                    },
                    {
                        name: 'sellerName',
                        caption: 'Продавец'
                    },
                    {
                        name: 'vendor',
                        caption: 'Производитель'
                    },
                    {
                        name: 'goodsTypeName',
                        caption: 'Тип'
                    },
                    {
                        name: 'goodsName',
                        caption: 'Сорт'
                    },
                    {
                        name: 'Length',
                        caption: 'Длина',
                        type: 'number'
                    },
                    {
                        name: 'traderViewPrice',
                        caption: 'Цена',
                        type: 'range'
                    }
                ],
                source: items
            });

            this.filter.trigger('filterChanged');


            return data;
        },

        onFilterChanged: function() {
            this.onSearchChanged();
        },

        onSearchChanged: function() {
            this.searchedData = utils.applySearch(this.filter.get('filtered'), this.get('search'));

            this.onScrollTopChanged();
        },

        onScrollTopChanged: function () {

            var items = this._applyPager(this.searchedData, this.get('viewRowIndex'));
            items = this._postProcessData(items, this.get('trade'));

            this.set('viewData', items, { silent: false });

            // this.trigger('filterChanged');
        },

        onScroll: function(top, height, resync) {
            var rowHeight = this.get('rowHeight');

            var viewRowIndex = this.get('viewRowIndex');
            var viewPageSize = this.get('viewPageSize');

            var viewBottomIndex = viewRowIndex + viewPageSize;

            var topRowIndex = (top / rowHeight);
            var bottomRowIndex = ((top + height) / rowHeight);

            var pageOffset = this.get('pageOffset');


            if (resync) {
                // viewRowIndex = topRowIndex;
                this.set('viewRowIndex', topRowIndex);
            }

            if (topRowIndex < viewRowIndex) { // scroll up
                // viewRowIndex = topRowIndex - pageOffset / 2;
                this.set('viewRowIndex', topRowIndex - pageOffset / 2);
            }

            if (viewBottomIndex < bottomRowIndex) { // scroll down
                // viewRowIndex = topRowIndex - pageOffset / 2;
                this.set('viewRowIndex', topRowIndex - pageOffset / 2);
            }

        },

        _applyPager: function(items, fromIndex) {
            var pageSize = this.get('pageSize');
            var rowHeight = this.get('rowHeight');

            fromIndex = Math.max(fromIndex, 0);
            var viewPageSize = Math.min(pageSize, items.length - fromIndex);
            var toIndex = fromIndex + viewPageSize;

            fromIndex = Math.max(toIndex - pageSize, 0);
            viewPageSize = toIndex - fromIndex;
            var result = items.slice(fromIndex, toIndex);

            if (fromIndex > 0) {
                result.unshift({ idx: -1, height: fromIndex * rowHeight });
            }
            if (toIndex < items.length) {
                result.push({ idx: -1, height: (items.length - toIndex) * rowHeight });
            }

            this.set('viewRowIndex', fromIndex);
            this.set('viewPageSize', viewPageSize);

            return result;
        },

        _postProcessData: function(items, trade) {
            var i, li, item, canBuy;

            canBuy = this.canBuy(trade);

            for (i=0, li = items.length; i<li; i++) {
                item = items[i];

                item.canBuy = canBuy;
            }

            return items;
        },

        canBuy: function(trade) {
            var et, ct, canBuy;

            trade = trade || this.get('trade');
            ct = (new Date()).getTime();
            canBuy = false;

            if (trade.startTime) {
                et = (new Date(trade.endTime)).getTime();
                canBuy = (ct <= et);
            }

            if (trade.startTimeOnline) {
                et = (new Date(trade.endTimeOnline)).getTime();
                canBuy = canBuy || (ct <= et);
            }

            canBuy = canBuy || (appCfg.environment === 'development');

            this.set('canBuy', canBuy);

            return canBuy;
        },

        updateCanBuy: function() {
            var canBuy = this.canBuy();

            _.each(this.filter.get('source'), function(item) {
                item.canBuy = canBuy;
            });
        },

        // applySearch: function(noTrigger) {
            // var items;
            // filter, currentFilter,
            // filtredData,
            // searchedData,
            // search,
            // pageData;

            // currentFilter = this.get('currentFilter');
            // search = ;

            // filter = this._getFilterInfo(items, currentFilter);
            // filtredData = this._applyFilter(items, filter);
            // filtredData = this._applySearch(filtredData, search);



            // this.set('visibleRows', filtredData.length);
            // this.set('searchedData', searchedData);
            // this.set('filter', filter.filterRanges);


            // items = this.items.get('filterData');
            // items = this._applySearch(items, this.get('search'));
            // items = this._applyPager(items, this.get('viewRowIndex'));
            // items = this._postProcessData(items, this.get('trade'));

            // this.set('viewData', items);

            // if (!noTrigger) { this.trigger('renderData'); }
        // },

        onUpdateBasketSum: function() {
            this.updateBasketSum();
        },

        updateBasketSum: function() {

            var sum = this.basket.reduce(function(memo, item) {
                return memo + item.get('traderViewPrice') * item.get('amount');
            }, 0);

            this.set('sum', sum);
        },


        urlParams: function() {
            var params = Model.prototype.urlParams.apply(this, arguments);
            params.tradeId = this.get('tradeId');
            params.state = this.get('state');
            return params;
        },

        timerStart: function() {
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }
            if (!this.timerEnabled) { return; }

            var _this = this;

            this.timeout = setTimeout(function() {
                _this.timeout = null;

                if (!_this.timerEnabled) { return; }

                _this.updateCanBuy();
                _this.timerStart();

            }, this.timerInterval);
        },

        dispose: function() {
            if (this.disposed) {
                return;
            }

            this.filter.dispose();
            this.filterList.dispose();

            if (this.timeout) { clearTimeout(this.timeout); }

            Model.prototype.dispose.apply(this, arguments);
        }
    });

    return TradePageModel;
});
